module.exports = __webpack_public_path__ + "img/HelpLsb1.a80f3eba.png";